import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import * as React from 'react';
export function baseTextStyle() {
  return {
    fontFamily: 'RalewayRegular, Helvetica, sans-serif',
    lineHeight: 1.38,
    letterSpacing: '0.5px',
    textAlign: 'left',
    color: '#ffffff',
    fontSize: '13px'
  };
}
export function mediumTextStyle() {
  return _objectSpread(_objectSpread({}, baseTextStyle()), {}, {
    fontFamily: 'RalewayMedium, Helvetica, sans-serif'
  });
}
export function boldTextStyle() {
  return _objectSpread(_objectSpread({}, baseTextStyle()), {}, {
    fontFamily: 'RalewayBold, Helvetica, sans-serif'
  });
}
export function commonAnimationKeyframes() {
  return React.createElement('style', {}, '' + '    @keyframes rotate {\n' + '        from {\n' + '            transform: rotate(0);\n' + '        }\n' + '        to {\n' + '            transform: rotate(360deg);\n' + '        }\n' + '    }\n' + '\n' + '    @keyframes fade-in {\n' + '        from {\n' + '            opacity: 0.6;\n' + '        }\n' + '        to {\n' + '            opacity: 1;\n' + '        }\n' + '    }\n');
}
export function hoverStyles() {
  var infoOverlayFilledBtnClass = 'viewer-common-info-overlay-button-filled';
  var infoOverlayFilledBtnHoverStyle = 'background: rgba(25, 102, 204, 1) !important;';
  var infoOverlayTransparentBtnClass = 'viewer-common-info-overlay-button-transparent';
  var infoOverlayTransparentBtnHoverStyle = 'background: rgba(255, 255, 255, .0980392) !important;';
  return React.createElement('style', {}, `
        .${infoOverlayFilledBtnClass}:hover { ${infoOverlayFilledBtnHoverStyle} }
        .${infoOverlayTransparentBtnClass}:hover { ${infoOverlayTransparentBtnHoverStyle} }
    `);
}
export function infoOverlayTransitions() {
  return React.createElement('style', {}, `
        .viewer-common-metadata-appear {
            opacity: .01;
            top: -20px;
        }
        .viewer-common-metadata-appear.viewer-common-metadata-appear-active {
            opacity: 1;
            top: 0;
            transition: opacity .5s ease-in, top .5s ease;
        }
        .viewer-common-info-overlay {
            pointer-events: auto;
        }
        .viewer-common-info-overlay .viewer-common-info-overlay-center-block {
            pointer-events: auto;
        }
        .viewer-common-info-overlay-transition-enter {
            opacity: .01;
        }
        .viewer-common-info-overlay-transition-enter.viewer-common-info-overlay-transition-enter-active {
            opacity: 1;
            transition: opacity .5s ease;
        }
        .viewer-common-info-overlay-transition-leave {
            opacity: 1;
        }
        .viewer-common-info-overlay-transition-leave.viewer-common-info-overlay-transition-leave-active {
            opacity: .01;
            transition: opacity .5s ease;
        `);
}
var baseForegroundStyle = {
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0
};
export var foregroundStyle = _objectSpread({
  zIndex: 3
}, baseForegroundStyle);
export var centeringBlockStyle = _objectSpread({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  pointerEvents: 'none'
}, baseForegroundStyle);